import { JsonReader } from '../../imports/jsonReader';

const categoryLoader = () => {
  const jsonFileContents = new JsonReader('./Assets/media/data/dataFile.json');
  const selectInput = document.querySelector('.js-category-value');
  const selectList = document.querySelector('.js-category-select');
  const linkList = document.querySelector('.js-category-list');
  const detailUrl = 'detail.html';
  let htmlStructListItem = document.querySelector('.js-category-list-item') as HTMLElement;
  

  // Start -- Category change
  function changeCateg( e:any ) {
    let categName = e.currentTarget.getAttribute('value');

    if (linkList) {
      // Data list
      jsonFileContents.getByCategory(categName)
        .then( jsonData => {
          linkList.innerHTML = '';
    
          if (jsonData.length > 0 && htmlStructListItem ) {
            jsonData.forEach( (element:any) => {
              let itemLink = htmlStructListItem.querySelector('a');
    
              if (itemLink) {
                let hrefUrl = detailUrl + '?id=' + element.id + '&categ=' + element.familyname;
                itemLink.href = hrefUrl;
                if (element.displayname != '' && element.displayname != null) {
                  itemLink.innerHTML = element.displayname;
                } else {
                  itemLink.innerHTML = element.name;
                }
              }
    
              let temp = htmlStructListItem.cloneNode(true);
              linkList.appendChild(temp);
            });
          }

          linkList.scrollTop = 0;

          
          if (window.innerWidth <= 767) {
            //@ts-ignore
            new SimpleBar(linkList, { autoHide: false } );
          }
        })
        .catch( error => {
          console.error('Error:', error);
        })
      ;
    }
  }
  // End -- Category change
  
  // START -- Initial Load --
  if (selectInput && selectList) {
    // Category List
    jsonFileContents.getContents('category')
      .then( jsonData => {
        if (jsonData) {
          let htmlStruct = document.querySelector('.js-category-select-item') as HTMLObjectElement;
          selectInput.innerHTML = jsonData[0].name;
          selectList.innerHTML = '';
          
          if (htmlStruct) {
            jsonData.forEach( (element:any) => {
              htmlStruct.setAttribute('value', element.name);
              htmlStruct.innerHTML = element.name;
              let temp = htmlStruct.cloneNode(true);
              temp.addEventListener('click', changeCateg);
              selectList.appendChild(temp);
            });
          }

          //@ts-ignore
          new SimpleBar(selectList, { autoHide: false });
        }
      })
      .catch( error => {
        console.error('Error:', error);
      })
    ;
  }

  if (linkList) {
    // Data list
    jsonFileContents.getByCategory('all')
      .then( jsonData => {
        linkList.innerHTML = '';

        if (jsonData.length > 0 && htmlStructListItem ) {
          jsonData.forEach( (element:any) => {
            let itemLink = htmlStructListItem.querySelector('a');

            if (itemLink) {
              let hrefUrl = detailUrl + '?id=' + element.id + '&categ=' + element.familyname;
              itemLink.href = hrefUrl;
              if (element.displayname != '' && element.displayname != null) {
                itemLink.innerHTML = element.displayname;
              } else {
                itemLink.innerHTML = element.name;
              }
            }

            let temp = htmlStructListItem.cloneNode(true);
            linkList.appendChild(temp);
          });
        }

        if (window.innerWidth <= 767) {
          //@ts-ignore
          new SimpleBar(linkList, { autoHide: false } );
        }
      })
      .catch( error => {
        console.error('Error:', error);
      })
    ;
  }
  // End -- Initial Load --
};
  
export default categoryLoader;